
export class Address {
    id: number = 0;
    name = '';
    cityId: number = 0;

    created = '';
    lastUpdated = '';
    lastUpdatedBy = '';
  
    constructor (name: string, cityId: number)  {
      this.cityId = cityId!;
      this.name = name!;
    }
  }

  export class PhoneNumber {
    code: number = 0;
    number: number = 0;
  
    constructor ()  {

    }
  }
  